<h2 class="modal-title">Create a Trade Account</h2>
<p class="modal-dec"><a class="link" (click)="viewEligibilityCriteriaPdf()">View</a> our trade account
    eligibility criteria</p>
<form [formGroup]="registerForm" (ngSubmit)="register()">
    @if(tradeLogo) {
    <img class="trade-logo" [src]="tradeLogo" alt="Logo" width="100" height="100" appHandleImageError />
    }
    <div class="form-group-row">
        <div class="form-group">
            <label class="form-label">ABN<span class="req">*</span></label>
            <input type="text" class="form-control" placeholder="Enter your ABN" formControlName="abn"
                [imask]="abnMaskConfiguration" [unmask]="true">
            @if((tf['abn'].invalid && tf['abn'].touched || submitted) || tf['abn'].errors?.apiError) {
            @if(tf['abn']?.errors?.required) {
            <span class="required-message">Please enter ABN</span>
            }
            @if(!tf['abn'].errors?.required && tf['abn'].errors?.abnNotValid) {
            <span class="required-message">Please enter a valid ABN</span>
            }
            @if(tf['abn'].errors?.apiError) {
            <span class="required-message">{{tf['abn'].errors?.apiError}}</span>
            }
            }
        </div>
    </div>
    @if(isShowFormOtherField){
    <div class="form-group-row">
        @if(tradeType && tradeType.length > 0 && !isShowTradeTypeDropdown) {
        <div class="form-group">
            <label class="form-label">Companies Primary Activity<span class="req">*</span></label>
            <ng-select class="ng-select-form-control" [items]="tradeType" [virtualScroll]="true" bindLabel="name" bindValue="id"
                placeholder="Select Companies Primary Activity" formControlName="trade_type_id">
            </ng-select>
            @if((tf['trade_type_id'].invalid && tf['trade_type_id'].touched || submitted) ||
            tf.trade_type_id.errors?.apiError){
            @if(tf.trade_type_id.errors?.required) {
            <span class="required-message">Please select companies primary activity</span>
            }
            }
        </div>
        }
        <div class="form-group">
            <label class="form-label">Company Name<span class="req">*</span></label>
            <input type="text" class="form-control" placeholder="Enter your Company Name" formControlName="company_name"
                (keydown.enter)="$event.preventDefault()" [readonly]="userDetailsDisable">
            @if((tf['company_name'].invalid && tf['company_name'].touched || submitted) ||
            tf.company_name.errors?.apiError){
            @if(tf.company_name.errors?.required) {
            <span class="required-message">Please enter company name</span>
            }
            @if(tf.company_name.errors?.apiError) {
            <span class="required-message">{{tf.company_name.errors?.apiError}}</span>
            }
            }
        </div>
    </div>
    <div class="form-group-row">
        <div class="form-group">
            <label class="form-label">Business Address Line 1<span class="req">*</span></label>
            <input type="text" class="form-control" placeholder="Enter your Business Address Line 1" (keydown.enter)="$event.preventDefault()" [class.is-invalid]="(tf['address_line_1'].invalid && tf['address_line_1'].touched || submitted) || tf.address_line_1.errors?.apiError || tf.address_line_1.errors?.streetRequired"
            [class.is-valid]="tf['address_line_1'].valid" formControlName="address_line_1" type="text"
            ngx-gp-autocomplete #ngxPlaces [options]='options'
            (onAddressChange)="handleCompanyAddressChange($event)" >
            @if((tf['address_line_1'].invalid && tf['address_line_1'].touched || submitted) ||
            tf.address_line_1.errors?.apiError || tf.address_line_1.errors?.streetRequired) {
            @if(tf.address_line_1.errors?.required) {
            <span class="required-message">Please enter business address line 1</span>
            }
            @if(tf.address_line_1.errors?.streetRequired) {
            <span class="required-message">{{tf.address_line_1.errors?.streetRequired}}</span>
            }
            @if(tf.address_line_1.errors?.apiError) {
            <span class="required-message">{{tf.address_line_1.errors?.apiError}}</span>
            }
            @if(!tf['address_line_1'].errors?.required && tf['address_line_1'].errors?.addressNotValid) {
            <span class="required-message">PO-box's may not be nominated, as couriers cannot deliver samples to these addresses.</span>
            }
            }
        </div>
    </div>
    <div class="form-group-row">
        <div class="form-group">
            <label class="form-label">Business Address Line 2</label>
            <input type="text" class="form-control" placeholder="Enter your Business Address Line 2"
                (keydown.enter)="$event.preventDefault()" formControlName="address_line_2">
        </div>
    </div>
    <div class="form-group-row">
        <div class="form-group">
            <label class="form-label">Suburb<span class="req">*</span></label>
            <input type="text" class="form-control" placeholder="Enter your Suburb" formControlName="suburb"
                (keydown.enter)="$event.preventDefault()">
            @if((tf['suburb'].invalid && tf['suburb'].touched || submitted) || tf.suburb.errors?.apiError) {
            @if(tf.suburb.errors?.required) {
            <span class="required-message">Please enter suburb</span>
            }
            @if(tf.suburb.errors?.apiError) {
            <span class="required-message">{{tf.suburb.errors?.apiError}}</span>
            }
            }
        </div>
        <div class="form-group">
            <label class="form-label">City<span class="req">*</span></label>
            <input type="text" class="form-control" placeholder="Enter your City" formControlName="town_city"
                (keydown.enter)="$event.preventDefault()">
            @if((tf['town_city'].invalid && tf['town_city'].touched || submitted) || tf.town_city.errors?.apiError)
            {
            @if(tf.town_city.errors?.required) {
            <span class="required-message">Please enter city</span>
            }
            @if(tf.town_city.errors?.apiError) {
            <span class="required-message">{{tf.town_city.errors?.apiError}}</span>
            }
            }
        </div>
    </div>
    <div class="form-group-row">
        <div class="form-group">
            <label class="form-label">State<span class="req">*</span></label>
            <input type="text" class="form-control" placeholder="Enter your State" formControlName="state_region"
                (keydown.enter)="$event.preventDefault()">
            @if((tf['state_region'].invalid && tf['state_region'].touched || submitted) ||
            tf.state_region.errors?.apiError)
            {
            @if(tf.state_region.errors?.required) {
            <span class="required-message">Please enter state</span>
            }
            @if(tf.state_region.errors?.apiError) {
            <span class="required-message">{{tf.state_region.errors?.apiError}}</span>
            }
            }
        </div>
        <div class="form-group">
            <label class="form-label">Postal Code<span class="req">*</span></label>
            <input type="text" class="form-control" placeholder="Enter your Postal Code" formControlName="post_code"
                numbersOnly maxlength="4" (keydown.enter)="$event.preventDefault()">
            @if((tf['post_code'].invalid && tf['post_code'].touched || submitted) || tf.post_code.errors?.apiError)
            {
            @if(tf.post_code.errors?.required) {
            <span class="required-message">Please enter postal code</span>
            }
            @if(tf.post_code.errors?.pattern) {
            <span class="required-message">Please enter valid postal code</span>
            }
            @if(tf.post_code.errors?.apiError) {
            <span class="required-message">{{tf.post_code.errors?.apiError}}</span>
            }
            }
        </div>
    </div>
    <div class="form-group-row">
        <div class="form-group">
            <label class="form-label">Country<span class="req">*</span></label>
            <input type="text" class="form-control" placeholder="Enter your Country" formControlName="country">
            @if((tf['country'].invalid && tf['country'].touched || submitted) ||
            tf.country.errors?.apiError)
            {
            @if(tf.country.errors?.required) {
            <span class="required-message">Please enter country</span>
            }
            @if(tf.country.errors?.apiError) {
            <span class="required-message">{{tf.country.errors?.apiError}}</span>
            }
            }
        </div>
    </div>
    <div class="form-group-row">
        <div class="form-group">
            <label class="form-label">Website<span class="req">*</span></label>
            <input type="text" class="form-control" placeholder="Enter your Website" formControlName="website"
                (keydown.enter)="$event.preventDefault()">
            @if((tf['website'].invalid && tf['website'].touched || submitted) || tf.website.errors?.apiError)
            {
            @if(tf.website.errors?.required) {
            <span class="required-message">Please enter website</span>
            }
            @if(tf.website.errors?.pattern) {
            <span class="required-message">Please enter valid url</span>
            }
            @if(tf.website.errors?.apiError) {
            <span class="required-message">{{tf.website.errors?.apiError}}</span>
            }
            }
        </div>
    </div>
    <div class="form-group-row">
        <div class="form-group">
            <label class="form-label">First Name<span class="req">*</span></label>
            <input type="text" class="form-control" placeholder="Enter your First Name" formControlName="first_name"
                (keydown.enter)="$event.preventDefault()">
            @if((tf['first_name'].invalid && tf['first_name'].touched || submitted) ||
            tf.first_name.errors?.apiError) {
            @if(tf.first_name.errors?.required) {
            <span class="required-message">Please enter first name</span>
            }
            @if(!tf.first_name.errors?.required && tf['first_name'].hasError('whitespace')) {
            <span class="required-message">First name cannot contain whitespace</span>
            }
            @if(!tf.first_name.errors?.required && tf.first_name.errors !== null && tf.first_name.errors) {
            <span class="required-message">Please enter only alphabets</span>
            }
            @if(tf.first_name.errors?.apiError) {
            <span class="required-message">{{tf.first_name.errors?.apiError}}</span>
            }
            }
        </div>
        <div class="form-group">
            <label class="form-label">Last Name<span class="req">*</span></label>
            <input type="text" class="form-control" placeholder="Enter your Last Name" formControlName="last_name"
                (keydown.enter)="$event.preventDefault()">
            @if((tf['last_name'].invalid && tf['last_name'].touched || submitted) ||
            tf.last_name.errors?.apiError) {
            @if(tf.last_name.errors?.required) {
            <span class="required-message">Please enter last name</span>
            }
            @if(!tf.last_name.errors?.required && tf['last_name'].hasError('whitespace')) {
            <span class="required-message">Last name cannot contain whitespace</span>
            }
            @if(!tf.last_name.errors?.required && tf.last_name.errors !== null && tf.last_name.errors) {
            <span class="required-message">Please enter only alphabets</span>
            }
            @if(tf.last_name.errors?.apiError) {
            <span class="required-message">{{tf.last_name.errors?.apiError}}</span>
            }
            }
        </div>
    </div>
    <div class="form-group-row">
        <div class="form-group">
            <label class="form-label">Job Title</label>
            <input type="text" class="form-control" placeholder="Enter your Job Title" formControlName="job_title"
                (keydown.enter)="$event.preventDefault()">
        </div>
        <div class="form-group">
            <label class="form-label">Business Role<span class="req">*</span></label>
            <ng-select class="ng-select-form-control" [items]="businessRole" [virtualScroll]="true" bindLabel="name" bindValue="id"
                placeholder="Select Business Role" formControlName="business_role_id">
            </ng-select>
            @if((tf['business_role_id'].invalid && tf['business_role_id'].touched || submitted) ||
            tf.business_role_id.errors?.apiError) {
            @if(tf.business_role_id.errors?.required) {
            <span class="required-message">Please select business role</span>
            }
            }
        </div>
    </div>
    <div class="form-group-row">
        <div class="form-group">
            <label class="form-label">Mobile<span class="req">*</span></label>
            <input type="text" class="form-control" placeholder="Enter your Mobile"
                [imask]="mobileMaskConfiguration" [unmask]="true" formControlName="mobile"
                (keydown.enter)="$event.preventDefault()">
            @if((tf['mobile'].invalid && tf['mobile'].touched || submitted) || tf.mobile.errors?.apiError) {
            @if(tf.mobile.errors?.required) {
            <span class="required-message">Please enter mobile</span>
            }
            @if(tf.mobile.errors?.minlength && !tf['mobile'].errors?.mobileNotValid) {
            <span class="required-message">Please enter at least 10 characters</span>
            }
            @if(!tf['mobile'].errors?.required && tf['mobile'].errors?.mobileNotValid) {
            <span class="required-message">Must be a valid australian mobile number</span>
            }
            @if(tf.mobile.errors?.apiError) {
            <span class="required-message">{{tf.mobile.errors?.apiError}}</span>
            }
            }
        </div>
    </div>
    <div class="form-group-row">
        <div class="form-group">
            <label class="form-label">Email<span class="req">*</span></label>
            <input type="email" class="form-control" placeholder="Enter your Email" formControlName="email"
                (change)="confirmEmailAddress($event)"
                (keydown.enter)="$event.preventDefault(); confirmEmailAddress($event)" autocomplete="off">
            @if((tf['email'].invalid && tf['email'].touched || submitted) || tf.email.errors?.apiError) {
            @if(tf.email.errors?.required) {
            <span class="required-message">Please enter email</span>
            }
            @if(tf.email.errors?.pattern) {
            <span class="required-message">Please enter a valid email address</span>
            }
            @if(tf.email.errors?.apiError) {
            <span class="required-message">{{tf.email.errors?.apiError}}</span>
            }
            }
        </div>
    </div>
    <div class="form-group-row">
        <div class="form-group">
            <label class="form-label">Confirm Email<span class="req">*</span></label>
            <input type="email" class="form-control" placeholder="Enter your Confirm Email"
                formControlName="confirm_email" onpaste="return false" #confirmEmailInput
                (keydown.enter)="$event.preventDefault()" autocomplete="off">
            @if((tf['confirm_email'].invalid && tf['confirm_email'].touched || submitted) ||
            tf.confirm_email.errors?.apiError) {
            @if(tf.confirm_email.errors?.required) {
            <span class="required-message">Please enter confirm email</span>
            }
            @if(tf.confirm_email.errors?.pattern) {
            <span class="required-message">Please enter a valid confirm email address</span>
            }
            @if(!tf.confirm_email.errors?.required && !tf.confirm_email?.hasError('pattern') &&
            tf.confirm_email.errors?.confirmEmailNotMatch) {
            <span class="required-message">Email and Confirm Email does not match</span>
            }
            @if(tf.confirm_email.errors?.apiError) {
            <span class="required-message">{{tf.confirm_email.errors?.apiError}}</span>
            }
            }
        </div>
    </div>
    <div class="form-group-row">
        <div class="form-group">
            <label class="form-label">Password<span class="req">*</span></label>
            <input type="password" class="form-control" placeholder="Enter your Password"
                (keydown.enter)="$event.preventDefault()" formControlName="password">
            @if((tf['password'].invalid && tf['password'].touched || submitted) || tf.password.errors?.apiError) {
            @if(tf.password.errors?.required) {
            <span class="required-message">Please enter password</span>
            }
            @if(tf.password.errors?.minlength) {
            <span class="required-message">Please enter at least 6 characters</span>
            }
            @if(tf.password.errors?.apiError) {
            <span class="required-message">{{tf.password.errors?.apiError}}</span>
            }
            }
        </div>
        <div class="form-group">
            <label class="form-label">Confirm Password<span class="req">*</span></label>
            <input type="password" class="form-control" placeholder="Enter your Confirm Password"
                formControlName="confirm_password" (keydown.enter)="$event.preventDefault()">
            @if((tf['confirm_password'].invalid && tf['confirm_password'].touched || submitted) ||
            tf.confirm_password.errors?.apiError) {
            @if(tf.confirm_password.errors?.required) {
            <span class="required-message">Please enter confirm password</span>
            }
            @if(!tf.confirm_password.errors?.required && tf.confirm_password.errors?.passwordNotMatch) {
            <span class="required-message">Password and Confirm Password does not match</span>
            }
            @if(tf.confirm_password.errors?.apiError) {
            <span class="required-message">{{tf.confirm_password.errors?.apiError}}</span>
            }
            }
        </div>
    </div>
    <div class="form-group d-flex align-items-center justify-content-between">
        <label class="custom-checkbox">
            <input type="checkbox" data-md-icheck="" formControlName="is_subscribed">
            <span class="checkmark"></span>
            Subscribe to our Newsletter
        </label>
    </div>
    }
    <div class="form-group mb-0">
        <button type="submit" class="btn btn-primary" [disabled]="registerForm.invalid">
            <span class="btn-primary-hover"></span>
            <span class="btn-content">Create Account</span>
        </button>
    </div>
</form>
